import React from 'react';
import { ReactQueryProvider } from '@/utils/ReactQuery';
import LiveSessionsMonitor from './LiveSessionsMonitor';

const LiveSessionsMonitorEntry = () => (
  <ReactQueryProvider>
    <LiveSessionsMonitor />
  </ReactQueryProvider>
);

export default LiveSessionsMonitorEntry;
